import { FunctionComponent, useEffect, useRef, useState } from 'react';
import anime from 'animejs';
import styles from './section4.module.css';
const Section4: FunctionComponent = () => {
  const [playAnimation, setPlayAnimation] = useState(false);
  const imageRef = useRef<HTMLImageElement>(null);
  const sectionRef = useRef<HTMLDivElement>(null);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    anime({
      targets: '.animatedPath',
      strokeDasharray: [anime.setDashoffset, 0],
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: 'easeInOutSine',
      duration: 3000,
      delay: (el: any, i: number) => i * 500,
      loop: true,
      complete: () => {
        // Apply glow effect
        anime({
          targets: '.glowingLogo',
          boxShadow: [
            '0px 0px 0px rgba(102, 51, 153, 0)',  // Start with no glow
            '0px 0px 20px rgba(102, 51, 153, 1)'  // Strong purple glow
          ],
          duration: 1000,
          easing: 'easeInOutQuad',
          direction: 'alternate',
          loop: 3,
        });
      },
    });

    // Moving circles animation
    document.querySelectorAll('.animatedPath').forEach((path, index) => {
      anime({
        targets: `.movingDot-${index}`,
        translateX: anime.path(path as SVGPathElement)('x'),
        translateY: anime.path(path as SVGPathElement)('y'),
        easing: 'linear',
        duration: 3000,
        loop: false,
        direction: 'normal',
      });
    });
  }, []);


  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setPlayAnimation(false); // Reset animation
          setTimeout(() => setPlayAnimation(true), 100); // Restart animation

        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (playAnimation) {
      anime({
        targets: `.${styles.image146Icon}`,
        clipPath: [
          "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)", // Fully hidden
          "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)", // Fully visible
        ],
        easing: "easeOutExpo",
        duration: 8000,
      });
    }
  }, [playAnimation]);
  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
  
    if (isMobile) {
      // Animate mobile-only paths from top to bottom
      document.querySelectorAll('.mobileOnly').forEach((path, index) => {
        anime({
          targets: path,
          strokeDasharray: [anime.setDashoffset, 0],
          strokeDashoffset: [anime.setDashoffset, 0],
          easing: 'easeInOutSine',
          duration: 3000,
          delay: index * 500,
        });
  
        anime({
          targets: `.movingDot-mobile-${index}`,
          translateX: anime.path(path as SVGPathElement)('x'),
          translateY: anime.path(path as SVGPathElement)('y'),
          easing: 'linear',
          duration: 3000,
          loop: false,
          direction: 'normal',
        });
      });
    }
  }, []);
  
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated) {
          anime.timeline()
            .add({
              targets: `.${styles.image146Icon}`,
              translateY: ["100vh", "-20vh"], // Shoots past final position
              scale: [0.8, 1.5], // Rapid scale expansion
              opacity: [0, 1], // Fades in
              easing: "easeInQuad", // Fast initial acceleration
              duration: 1000, // Quick launch
            })
            .add({
              targets: `.${styles.image146Icon}`,
              translateY: ["-20vh", "0vh"], // Falls back into place
              scale: [1.5, 1], // Settles to normal size
              easing: "easeOutElastic(1, 0.5)", // Bouncy landing
              duration: 1500, // Slower settling time
            });

          setHasAnimated(true);
        }
      },
      {
        rootMargin: "100px 0px",
        threshold: 0.2, // Start animation when 20% of the image is visible
      }
    );

    if (imageRef.current) observer.observe(imageRef.current);

    return () => observer.disconnect();
  }, [hasAnimated]);

  return (
    <div className={styles.frameParent} ref={sectionRef} style={{ paddingTop: "300px" }}>
      <div className={styles.omnichannelFunctionalityParent}>
        <div className={styles.omnichannelFunctionality}>Omnichannel Functionality</div>
        <div className={styles.aiMeetsFieldExecutionSmarParent}>
          <div className={styles.aiMeetsField}>AI Meets Field Execution: Smarter Recoveries, Faster Resolution</div>
          <div className={styles.trustedByClients}>Engage borrowers intelligently across every stage of delinquency with automated, personalized outreach—via voice, WhatsApp, SMS, and field. Drive higher recovery rates with one powerful, data-driven platform.</div>
        </div>
      </div>
      <div className={styles.groupWrapper}>
        <div className={styles.image146Parent}>
          <img className={styles.image146Icon} alt="" src="./assets/ironman.svg" />
          <div className={styles.divcontainer}>
            <img className={styles.d9978c514281070aa6774310035e36Icon} alt="" src="./assets/grid.png" />
           {/* Desktop Image */}
           <img
  className={`${styles.overlayImage} glowingLogo hidden md:block`}
  alt=""
  src="./assets/iconbg.png"
/>

{/* Mobile only (hidden on desktop) */}
<img
  className={`${styles.overlayImage} block md:hidden`}
  alt=""
  src="./assets/section4img.svg"
/>


            <div className={styles.overlayWrapper}>
              <img className={styles.maskGroupIcon} alt="" src="./assets/iconring.png" />
              <img className={styles.topOverlayImage} alt="" src="./assets/crdhs.png" />
            </div>

            <div className={styles.rightGrid}>
              {Array.from({ length: 9 }).map((_, index) => (
                <div key={index}>
                  <img className={styles.smallGridImage} alt="" src={`./assets/gridcard${index + 1}.svg`} />
                </div>
              ))}
            </div>

            <div className={styles.leftGrid}>
              {Array.from({ length: 4 }).map((_, index) => (
                <div key={index} className={styles.frameWrapper}>
                  {/* <img className={styles.frameRing} alt="" src="./assets/framering.svg" /> */}
                  <img className={styles.leftGridImage} alt="" src={`./assets/leftcard${index + 1}.svg`} />
                </div>
              ))}
            </div>

            <svg className={styles.animatedSVG} viewBox="0 0 800 400" width="100%" height="100%">
              <defs>
              <linearGradient id="greenGradient" x1="0%" y1="0%" x2="100%" y2="0%">
  <stop offset="0%" stopColor="#A8E6A3" />   {/* Soft mint green */}
  <stop offset="50%" stopColor="#5AC86B" />  {/* Fresh medium green */}
  <stop offset="100%" stopColor="#2F8F44" /> {/* Rich forest green */}
</linearGradient>

              </defs>
              {Array.from({ length: 4 }).map((_, index) => (
                <>
                  <path
                    key={index}
                    d={`M400,160 Q200,${110 + index * 80} 150,${60 + index * 90}`}
                    className="animatedPath"
                    stroke="url(#greenGradient)"
                    strokeWidth="1"
                    fill="none"
                  />
                  <circle className={`movingDot-${index}`} r="5" fill="white" />
                </>
              ))}
              {Array.from({ length: 3 }).map((_, index) => (
                <>
                  <path
                    key={index}
                    d={`M400,160 Q580,${70 + index * 80} 620,${60 + index * 130}`}
                    className="animatedPath"
                    stroke="url(#greenGradient)"
                    strokeWidth="1"
                    fill="none"
                  />
                  <circle className={`movingDot-${index + 4}`} r="5" fill="white" />
                </>
              ))}
             
 


              
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section4;